/*-----------------------------------------------------------------
- Message translations
-----------------------------------------------------------------*/
export default {

    complete  : 'منجز',
    loading   : 'عمل',
    pending   : 'انتظار',
    of_step   : '{0} من {1}',
    on_loading: 'تحميل ...',
    empty     : 'هذا القسم فارغ.',

    error: {
        upload: {
            common: 'هناك مشكلة في التحميل.',
        },
    },

    success: {
        upload: {
            common: 'تم تحميل ملفك بنجاح.',
        },
    },

    cloner: {
        confirm_delete    : 'هل أنت متأكد من حذف هذا العنصر؟',
        confirm_delete_all: 'هل أنت متأكد أنك تريد حذف كافة العناصر؟',
    },

    login_first: 'الرجاء تسجيل الدخول أولا.',

};
